import * as React from 'react';

import { SVGProps } from '../../types';

export const IconExtractQuestionsSvg = ({
  title,
  titleId,
  ...props
}: SVGProps) => (
  <svg
    width={36}
    height={36}
    viewBox="0 0 36 36"
    focusable="false"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}

    <path
      d="M7.75 4C7.75 3.44772 8.19772 3 8.75 3H20H25.6712C25.9596 3 26.2339 3.12448 26.4238 3.3415L32.0026 9.71723C32.1621 9.89952 32.25 10.1335 32.25 10.3757V19V32C32.25 33.6569 30.9069 35 29.25 35H8.75C8.19771 35 7.75 34.5523 7.75 34V4Z"
      fill="#E4FBFF"
    />
    <path
      d="M5.75 3C5.75 1.89543 6.64543 1 7.75 1H18H23.6712C23.9596 1 24.2339 1.12448 24.4238 1.3415L30.0026 7.71723C30.1621 7.89952 30.25 8.13351 30.25 8.37574V17V31C30.25 32.1046 29.3546 33 28.25 33H7.75C6.64543 33 5.75 32.1046 5.75 31V3Z"
      stroke="#0099C7"
      strokeWidth="1.5"
    />
    <path
      d="M30 9H24C23.4477 9 23 8.55228 23 8V1"
      stroke="#0099C7"
      strokeWidth="1.5"
    />
    <path
      d="M22.1095 16.3715V23.3599H15.1211"
      stroke="#0099C7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.7355 22.9855L13 14.25"
      stroke="#0099C7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
